import { create } from "zustand";
import { persist } from "zustand/middleware";
import { apiService } from "../api/apiService";

const useUserStore = create(
  persist(
    (set, get) => ({
      // 用户状态
      user: null,
      token: null,
      isLoggedIn: false,
      isLoading: false,
      error: null,

      // 登录
      login: async (email, password) => {
        set({ isLoading: true, error: null });
        try {
          const response = await apiService.login({ 
            email_or_phone: email, 
            password 
          });
          
          if (response.success) {
            set({ 
              user: { email }, // 服务器可能返回更多用户信息，这里简化处理
              token: response.token, 
              isLoggedIn: true, 
              isLoading: false 
            });
            return { success: true };
          } else {
            throw new Error(response.message || "登录失败");
          }
        } catch (error) {
          const errorMessage = error.response?.data?.message || error.message || "登录失败，请检查邮箱和密码";
          set({
            error: errorMessage,
            isLoading: false,
          });
          return { success: false, error: errorMessage };
        }
      },

      // 注册
      register: async (userData) => {
        set({ isLoading: true, error: null });
        try {
          const response = await apiService.register(userData);
          
          if (response.success) {
            // 注册成功后自动登录
            const loginResponse = await apiService.login({ 
              email_or_phone: userData.email, 
              password: userData.password 
            });
            
            if (loginResponse.success) {
              set({ 
                user: { 
                  email: userData.email, 
                  name: userData.name || userData.email.split('@')[0],
                  company: userData.company_name 
                },
                token: loginResponse.token,
                isLoggedIn: true, 
                isLoading: false 
              });
              return { success: true };
            } else {
              throw new Error(loginResponse.message || "注册成功但登录失败");
            }
          } else {
            throw new Error(response.message || "注册失败");
          }
        } catch (error) {
          const errorMessage = error.response?.data?.message || error.message || "注册失败，请稍后重试";
          set({
            error: errorMessage,
            isLoading: false,
          });
          return { success: false, error: errorMessage };
        }
      },

      // 退出
      logout: async () => {
        try {
          await apiService.logout();
        } catch (error) {
          console.error("Logout error:", error);
        } finally {
          set({ user: null, token: null, isLoggedIn: false });
        }
      },

      // 清除错误
      clearError: () => {
        set({ error: null });
      },
    }),
    {
      name: "user-storage", // 存储名称
      getStorage: () => localStorage, // 使用localStorage
      partialize: (state) => ({
        // 只持久化需要的数据，排除error字段
        user: state.user,
        token: state.token,
        isLoggedIn: state.isLoggedIn
      })
    }
  )
);

export default useUserStore;
